import customAxios from "./axiosConfig";

const FinancingService = {
    get: function (pk, params) {
        const api_url = window.Urls['financingstatus_detail'](pk);
        return customAxios.get(api_url, {params: params});
    },
    create: function (data) {
        const api_url = window.Urls['financingstatus_list']();
        return customAxios.post(api_url, data);
    },
    update: function (pk, data) {
        const api_url = window.Urls['financingstatus_detail'](pk);
        return customAxios.patch(api_url, data);
    }
}

export default FinancingService;
